import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import th from './th.json'
import en from './en.json'
import Backend from 'i18next-http-backend'
import { initLangKey } from '../../components/layout/SwitchLanguageButton'
import { appEnv } from '../../configs/app-env'

const resources = {
  th: {
    translation: th,
  },
  en: {
    translation: en,
  },
}

export const getInitLang = () => {
  const initLang = localStorage.getItem(initLangKey)
  if (!initLang) {
    localStorage.setItem(initLangKey, 'th')
    return 'th'
  }
  return initLang
}
const initLang = getInitLang()

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: initLang,
    // fallbackLng: 'th',
    ns: ['backend'],
    react: {
      useSuspense: false,
      wait: true,
    },
    backend: {
      loadPath: appEnv.apiHost.replace('/api/v1', '/locales/error-{{lng}}.json'),
    },
    resources,
    // debug: true,
  })
i18next.reloadResources()

export default i18next
